export enum BookingStatus {
  Requested = 0,
  Offered = 1,
  Booked = 2,
  Confirmed = 3,
  Done = 4,
  Reviewed = 5,
  Cancelled = 6
}